import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    overflow: "visible",
    cursor: "pointer",
    borderRadius: 0,
    border: "none",
    boxShadow: "none",
    margin: 0,
    width: 48,
    height: 48,
    minWidth: 48,
    minHeight: 48,
    borderColor: "transparent",
    borderRight: "1px solid #eeeeee",
    "&:last-child": {
      borderRight: `1px solid ${theme.palette.text.hint}`
    }
  },
  date: {
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    textAlign: "center",
    borderRadius: 3,
    fontSize: 14,
    height: 26,
    width: 26,
    boxShadow: "0 1px 7px 0 rgb(0, 0, 0, 0.08)"
  },
  loader: {
    position: "absolute",
    zIndex: 1,
    background: "rgba(255, 255, 255, 0.85)",
    padding: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: "100%",
    height: "100%",
    borderRadius: 0
  },
  squared: {
    color: theme.palette.text.primary,
    borderRadius: 2,
    width: 20,
    height: 20,
    border: "1px solid"
  }
}));
